import * as React from 'react'
import {Component} from 'react'

///////////////////////////////////////////////////////////////////////////////

interface ErrorBoundaryState {
  error: Error
}

///////////////////////////////////////////////////////////////////////////////

export class ErrorBoundary extends Component<any, ErrorBoundaryState> {
  constructor(props) {
    super(props)
    this.state = {error: null}
  }

  static getDerivedStateFromError(error) {
    return {error}
  }

  // componentDidCatch(error, errorInfo) {
  //   console.log('--> error', error)
  //   console.log('--> errorInfo', errorInfo)
  //   // logErrorToMyService(error, errorInfo)
  // }

  render() {
    if (this.state.error) {
      return (
        <section id="tamaro-widget" className="tamaro-widget">
          <div className="error-widget">
            <div className="header">
              <div className="title">
                <h2 className="text">There was an error</h2>
              </div>
            </div>
            <div className="main">
              <div className="text">{this.state.error.message}</div>
            </div>
          </div>
        </section>
      )
    }

    return this.props.children
  }
}
